/*
 * @Author: Miaoz
 * @Date: 2025-06-20 18:35:08
 * @LastEditors: Miaoz
 * @LastEditTime: 2025-06-24 11:08:54
 * @Description: 
 */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { px2dpSmall } from '../../../../../utils/px2dp';
import { shortImageSize } from '../../../../../utils/utils';
import { getByteCount } from '../../BytesCount';
import Request from '../../../../../utils/request';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/opacity.css';


const play_icon = 'http://static.shihuocdn.cn/admin/files/20230822/bec2fa4227fc27ff96840b74b80d8b0c.png'
const bottom_bg_icon = 'http://static.shihuocdn.cn/admin/files/20230807/03a59277acc673321aeb626eeba330c6.png'
const article_icon = 'http://static.shihuocdn.cn/admin/files/20230807/cdad47a3f86850e6156c087ae7ab7c53.png'
const praised_icon = 'http://static.shihuocdn.cn/app/res/dsgn/363d7402c5a1407f9e72d8077d158720.png'
const un_praised_icon = 'http://static.shihuocdn.cn/app/res/dsgn/79577cabf39d4dc09af2d48b42a7c267.png'
const praised_animated = 'http://static.shihuocdn.cn/admin/files/20220826/03074265e9e14ae2b18229bf516dfbd9.webp'
const animated_svga = 'http://static.shihuocdn.cn/app/res/dsgn/ab45f0ee9d5b454badb02fe85a29c256.svga'
const user_level_1 = 'http://static.shihuocdn.cn/admin/files/20220830/1dc074021fc6b5f706de782042fed04e.png'
const user_level_2 = 'http://static.shihuocdn.cn/admin/files/20220830/7f4f3d0a182686e5766946afa122a3f7.png'
const user_level_3 = 'http://static.shihuocdn.cn/admin/files/20220830/0a1a00fa186d88222513a22d12e474bc.png'

const screen = typeof window !== 'undefined' && window.screen;
const isIOS = typeof window !== 'undefined' && /ios|iphone|ipad/i.test(navigator.userAgent);
const vCardWidth = typeof window !== 'undefined' && (window.innerWidth - px2dpSmall(12) * 2 - px2dpSmall(9)) / 2;

const requestNotePraised = async (id, channel_type, is_praised) => {
    let url = 'http://apps.shihuo.cn/app_swoole_common/praise'
    let params = { id, channel_type, status: is_praised ? '1' : '2' }
    console.log('requestNotePraised', params)
    return new Promise((resolve, reject) => {
        Request({
            url,
            method: 'GET',
            params
        }).then(value => {
            resolve(value)
        }).catch(err => {
            reject(err)
        })
    })
}

function getUserLevelImg(level) {
    switch (level) {
        case 1:
            return user_level_1
        case 2:
            return user_level_2
        case 3:
            return user_level_3
        default:
            return user_level_1
    }
}
function getNoteNumberOfLines(item, widgetWidth) {
    let { name = '' } = item
    let lineWidth = widgetWidth - px2dpSmall(10) * 2
    return getNumberOfLines(name, lineWidth, px2dpSmall(13))
}

function getNumberOfLines(title, widgetWidth, fontSize) {
    let isContainSpace = title.indexOf('\n')
    if (isContainSpace < 0) {
        isContainSpace = title.indexOf('\r')
    }
    if (isContainSpace > -1) {
        return 2
    }
    let nameLength = getByteCount(title)
    let totalWidth = nameLength / 2.0 * fontSize
    if (totalWidth <= widgetWidth) {
        return 1
    } else {
        return 2
    }
}

function getWidgetHeight(item, widgetWidth) {
    const numberOfLines = getNoteNumberOfLines(item, widgetWidth)
    const data = item
    let { title = '', img_w = 1, img_h = 1 } = data
    let ratio = (img_h > 0 ? img_h : 1) / (img_w > 0 ? img_w : 1)
    ratio = Math.min(ratio, 4.0 / 3.0)
    ratio = Math.max(ratio, 3.0 / 4.0)
    let cardHeight = widgetWidth * ratio + px2dpSmall(9)
    cardHeight += px2dpSmall(8) // 图片和标题的间隔
    if (numberOfLines == 1) {
        cardHeight += px2dpSmall(18)
    }
    if (numberOfLines == 2) {
        cardHeight += px2dpSmall(18) * 2
    }
    cardHeight += (px2dpSmall(8) + px2dpSmall(18))
    return cardHeight
}

class SHNoteCommonVertFlatStyle3Widget extends Component {

    constructor(props) {
        super(props)
        this.state = ({
            animated: false,
            // dataSource: {}
        })
        this.cardWidth = props.cardWidth || vCardWidth
    }

    _isShowTip = (is_video, show_type, type, format_duration) => {
        let show = false
        let icon = ''
        let text = ''
        if (is_video == 1) {
            show = true
            icon = play_icon
            text = format_duration
        } else if (show_type == 'single28') {
            show = true
            icon = article_icon
            text = '文章'
        } else if (type == 1) {
            show = true
            icon = article_icon
            text = '攻略'
        }
        return { show, icon, text }
    }

    componentDidMount() {
        // this.setState({
        //     dataSource: this.props.dataSource || {}
        // })
    }

    _onLogin = () => {
        window.Jockey.send("action", {
          url: "shihuo://www.shihuo.cn?route=login",
        });
    }

    _onPress = () => {
        this.props.onPress && this.props.onPress()
    }

    _onZanPress = async () => {
        const isLogin = this.props.isLogin;
        if (!isLogin) {
            this._onLogin();
            return
        }

        const { itemIndex = 0 } = this.props
        let dataSource = this.props.dataSource
        let { note_id = '', channel_type = '4', is_praise = false, praiseNum = 0 } = dataSource
        praiseNum = parseInt(praiseNum)
        dataSource.is_praise = !is_praise
        praiseNum += (!is_praise ? 1 : -1)
        dataSource.praiseNum = praiseNum

        this.setState({
            animated: !is_praise,
        }, () => {
            const { animated = false } = this.state
            if (animated) {
                setTimeout(() => {
                    this.setState({
                        animated: false
                    })
                }, 400);
            }
        })
        requestNotePraised(note_id, channel_type, !is_praise).then(value => { }).catch(err => { })
    }

    render() {
        let {
            img = '',
            profilePic = '',
            nickname = '',
            praiseNum = '',
            img_w = 1,
            img_h = 1,
            praise = 0,
            is_praise = false,
            is_video = 0,
            video = {},
            name = '',
            format_duration = '00:00',
            show_type = '',
            type = 0,
            level = 0,
        } = this.props.dataSource
        const { h5_exposure_object = {} } = this.props

        const numberOfLines = getNoteNumberOfLines(this.props.dataSource, this.cardWidth)

        let ratio = (img_h > 0 ? img_h : 1) / (img_w > 0 ? img_w : 1)
        ratio = Math.min(ratio, 4.0 / 3.0)
        ratio = Math.max(ratio, 3.0 / 4.0)
        const {
            animated = false
        } = this.state
        img = img.split('#keepOn').join('')
        if (is_video == 1) {
            let videoImg = video.img || ''
            if (videoImg.length > 0) {
                img = videoImg.split('#keepOn').join('')
            }
        }
        const tipObj = this._isShowTip(is_video, show_type, type, format_duration)
        const containerHeight = getWidgetHeight(this.props.dataSource, this.cardWidth)
        return (
            <div
                ref={ele => {
                    if (ele) {
                        this.props.exp && this.props.exp(ele);
                    }
                }}
                data-dot={JSON.stringify(h5_exposure_object)}
                className='goods-card'
                style={{
                    ...styles.container,
                    width: this.cardWidth,
                    height: containerHeight - px2dpSmall(9),
                }}
            >
                <div
                    className='note-content'
                    style={styles.content}
                    onClick={() => this._onPress()}
                >
                    <div
                        className='node-img-wrap'
                        style={{
                            ...styles.img,
                            height: this.cardWidth * ratio,
                            position: 'relative',
                        }}
                    >
                        <LazyLoadImage
                            key={this.props.key}
                            className='node-img'
                            src={shortImageSize(img)}
                            effect="opacity"
                            wrapperProps={{
                                style: {
                                    transitionDuration: '700ms',
                                },
                            }}
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                borderRadius: styles.img.borderRadius,
                                display: 'block',
                            }}
                            // onClick={() => {
                            //     if (isIOS) {
                            //         this._onPress();
                            //     }
                            // }}
                        />
                        {tipObj.show ? (
                            <div
                                className='node-video'
                                style={{
                                    ...styles.video,
                                    backgroundImage: `url(${bottom_bg_icon})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    backgroundRepeat: 'no-repeat',
                                }}
                            >
                                <div
                                    className='node-video-text'
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        height: px2dpSmall(16),
                                        marginBottom: px2dpSmall(4),
                                        width: '100%',
                                        boxSizing: 'border-box',
                                    }}
                                >
                                    <img
                                        className='node-video-icon'
                                        src={tipObj.icon}
                                        alt="tip-icon"
                                        style={
                                            is_video == 1
                                                ? styles.video_icon
                                                : styles.article_icon
                                        }
                                    />
                                    <span
                                        style={styles.video_text}
                                        className='node-video-tip'
                                    >
                                        {tipObj.text}
                                    </span>
                                </div>
                            </div>
                        ) : null}
                    </div>
                    {name.length > 0 ? (
                        <p
                            className='node-title'
                            style={{
                                ...styles.title,
                                height: numberOfLines * px2dpSmall(18),
                                lineHeight: '18px',
                                display: '-webkit-box',
                                WebkitLineClamp: numberOfLines,
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                            }}
                        >
                            {name}
                        </p>
                    ) : null}

                    <div
                        className='node-bottom'
                        style={styles.bottom}
                    >
                        <div
                            className='node-avatar-wrap'
                            style={styles.avatar}
                        >
                            <img
                                className='node-avatar'
                                src={shortImageSize(profilePic, px2dpSmall(40))}
                                alt="avatar"
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    borderRadius: styles.avatar.borderRadius,
                                    objectFit: 'cover',
                                    display: 'block',
                                }}
                            />
                            {level != 0 ? (
                                <img
                                    className='node-avatar-level'
                                    src={shortImageSize(
                                        getUserLevelImg(level),
                                        px2dpSmall(16)
                                    )}
                                    alt="level"
                                    style={styles.avatar_level}
                                />
                            ) : null}
                        </div>

                        <span
                            className='node-author-name'
                            style={{
                                ...styles.author_name,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                            }}
                            title={nickname}
                        >
                            {nickname}
                        </span>

                        <div
                            className='node-zan-container'
                            style={styles.zanContainer}
                            onClick={(e) => {
                                e.stopPropagation();
                                this._onZanPress();
                            }}
                        >
                            <img
                                src={
                                    animated
                                        ? praised_animated
                                        : is_praise
                                            ? praised_icon
                                            : un_praised_icon
                                }
                                alt="like"
                                style={styles.zan}
                            />
                            <img
                                src={
                                    !is_praise ? praised_icon : un_praised_icon
                                }
                                alt=""
                                style={styles.zanPreload}
                            />
                            <span style={styles.zanNum}>{`${praiseNum}`}</span>
                        </div>
                    </div>
                    <div style={{ width: '100%', height: px2dpSmall(4) }} />
                </div>
            </div>
        )
    }
}

SHNoteCommonVertFlatStyle3Widget.propTypes = {
    dataSource: PropTypes.object,
    itemIndex: PropTypes.number,
    onZanPress: PropTypes.func
}

SHNoteCommonVertFlatStyle3Widget.defaultProps = {
    dataSource: {},
    itemIndex: 0,
    onZanPress: () => { }
}

const styles = {
    container: {
        marginBottom: px2dpSmall(9),
        overflow: 'hidden',
    },
    content: {
        width: '100%',
        borderRadius: 6,
        backgroundColor: '#ffffff',
        overflow: 'hidden',
        flex: 1
    },
    img: {
        width: '100%',
        height: px2dpSmall(233),
        overflow: 'hidden',
        borderRadius: 6,
    },
    video: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-end',
        // alignItems: 'center',
        // alignContent: 'flex-end',
        width: '100%',
        height: px2dpSmall(28),
    },
    video_icon: {
        marginLeft: px2dpSmall(10),
        width: px2dpSmall(9),
        height: px2dpSmall(12),
        marginTop: px2dpSmall(1),
    },
    article_icon: {
        marginLeft: px2dpSmall(10),
        width: px2dpSmall(10),
        height: px2dpSmall(11),
        marginTop: px2dpSmall(2),
    },
    video_text: {
        fontFamily: 'PingFangSC-Regular',
        fontSize: px2dpSmall(11),
        color: 'white',
        marginLeft: px2dpSmall(3),
    },
    title: {
        fontFamily: 'PingFangSC-Regular',
        fontSize: px2dpSmall(13),
        color: '#333333',
        marginTop: px2dpSmall(4),
        marginLeft: px2dpSmall(4),
        marginRight: px2dpSmall(4),
        textAlign: 'left'
    },
    bottom: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        height: px2dpSmall(18),
        marginTop: px2dpSmall(8),
        marginLeft: px2dpSmall(4),
        marginRight: px2dpSmall(4)
    },
    avatar: {
        width: px2dpSmall(18),
        height: px2dpSmall(18),
        borderRadius: px2dpSmall(18) / 2.0,
    },
    avatar_level: {
        width: px2dpSmall(9),
        height: px2dpSmall(8),
        position: 'absolute',
        right: -px2dpSmall(2),
        bottom: 0
    },
    author_name: {
        fontFamily: 'PingFangSC-Regular',
        fontSize: px2dpSmall(11),
        color: '#666666',
        marginLeft: px2dpSmall(5),
        flex: 1
    },
    zanContainer: {
        marginLeft: px2dpSmall(0),
        height: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    zan: {
        width: px2dpSmall(20),
        height: px2dpSmall(20),
    },
    zanPreload: {
        position: 'absolute',
        opacity: 0,
        backgroundColor: 'red',
        width: px2dpSmall(20),
        height: px2dpSmall(20),
    },
    zanNum: {
        marginLeft: px2dpSmall(0),
        fontFamily: 'PingFangSC-Regular',
        fontSize: px2dpSmall(12),
        color: '#666666',
        height: px2dpSmall(16)
    }
}

export default {
    widget: SHNoteCommonVertFlatStyle3Widget,
    getWidgetHeight,
    showStyleList: false,
}



// WEBPACK FOOTER //
// ./components/pipeline-recommend/lib/SHCard/widgets/SHNoteCommonVertFlatStyle3Widget.js